<div class="flex justify-content-between">
  <div>
    <span class="subtitle3Font">{{ index }}. </span>
    <span class="body2Font"
          i18n>{{ label }}</span>
  </div>
  <div class="field field-radiobutton m-0">
    @if (triState) {
      <p-radioButton [inputId]="itemControlName + 'NotApplicable'"
                     [name]="itemControlName"
                     [value]="reviewChecklistItemEnum.NotApplicable"
                     [formControl]="control">
      </p-radioButton>
      <label class="ml-2"
             [attr.for]="itemControlName + 'NotApplicable'"
             i18n>
        Not applicable
      </label>
    }

    <p-radioButton class="ml-5"
                   [inputId]="itemControlName + 'Yes'"
                   [name]="itemControlName"
                   [value]="triState ? reviewChecklistItemEnum.Yes : true"
                   [formControl]="control">
    </p-radioButton>
    <label class="ml-2"
           [attr.for]="itemControlName + 'Yes'"
           i18n>
      Yes
    </label>

    <p-radioButton class="ml-5"
                   [inputId]="itemControlName + 'No'"
                   [name]="itemControlName"
                   [value]="triState ? reviewChecklistItemEnum.No : false"
                   [formControl]="control">
    </p-radioButton>
    <label class="ml-2"
           [attr.for]="itemControlName + 'No'"
           i18n>
      No
    </label>
  </div>
</div>

@if (showDivider) {
  <p-divider></p-divider>
}